import PropTypes from 'prop-types';
import React from 'react';
import { TileGroup } from '@opendate-app/setlist';

import { FIELD_TYPES } from './customFieldHelpers';

const ICON_PATHS = {
  'CustomFields::Text': 'M4 7V4h16v3M9 20h6M12 4v16',
  'CustomFields::TextArea': 'M21 6H3M15 12H3M17 18H3',
  'CustomFields::Select': 'M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2zM8 10l4 4 4-4',
  'CustomFields::Checkbox': 'M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2zM9 12l2 2 4-4',
  'CustomFields::Date': 'M8 2v4M16 2v4M5 4h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2zM3 10h18',
  'CustomFields::Number': 'M4 9h16M4 15h16M10 3 8 21M16 3l-2 18',
  'CustomFields::Email': 'M4 4h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2zM22 7l-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7',
  'CustomFields::File': 'm21.44 11.05-9.19 9.19a6 6 0 0 1-8.49-8.49l8.57-8.57A4 4 0 1 1 18 8.84l-8.59 8.57a2 2 0 0 1-2.83-2.83l8.49-8.48',
  'CustomFields::Address': 'M12 21s-7-5.5-7-11a7 7 0 0 1 14 0c0 5.5-7 11-7 11zM12 12.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z',
  'CustomFields::Phone': 'M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.36 1.9.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.91.34 1.85.57 2.81.7A2 2 0 0 1 22 16.92z'
};

// One component per type, made once, so TileGroup sees a stable `icon`.
const iconFor = (type) => {
  const TypeIcon = (props) => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d={ICON_PATHS[type]} />
    </svg>
  );
  return TypeIcon;
};

const ICONS = Object.fromEntries(Object.keys(ICON_PATHS).map((type) => [type, iconFor(type)]));

export const fieldTypeIcon = (type) => ICONS[type] || ICONS['CustomFields::Text'];

const ITEMS = FIELD_TYPES.map((t) => ({ ...t, icon: ICONS[t.value] }));

const FieldTypeTiles = ({ value, onChange, disabled }) => (
  <TileGroup items={ITEMS} value={value} onChange={onChange} disabled={disabled} aria-label="Field type" />
);

FieldTypeTiles.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool
};

FieldTypeTiles.defaultProps = {
  disabled: false
};

export default FieldTypeTiles;
